import Swiper, {Navigation, Parallax, Pagination, Autoplay} from 'swiper';
import { cancelFrame, requestFrame } from '../utils/global-raf';

Swiper.use([Navigation, Parallax, Pagination, Autoplay]);

class Nav {
  public items: HTMLCollection;
  public nav: Element;
  public header: Element;
  public primaryMenu: Element;
  public menuSecondLevel: Element;
  public menuFirstLevel: Element;
  public menuToggler: HTMLCollection;
  public dropdowns: HTMLCollection;
  public backButtonSecondaryMenu: NodeListOf<Element>;
  public buttonCloseTernaryMenu: NodeListOf<Element>;
  public btOpenTernaryMenu: NodeListOf<Element>;
  private menusTernaryLevel: NodeListOf<Element>
  private topBar: HTMLElement;
  private btBackSecondaryMenuTopBar: HTMLElement;
  private btBackTernaryMenuTopBar: HTMLElement;
  private linksPrimaryMenuTopBar: NodeListOf<HTMLElement>;
  private linksContainerPrimaryMenuTopBar: HTMLElement;
  private linksPrimaryMenuTopBarTertiary: NodeListOf<HTMLElement> | null;

  public innerMenu: HTMLCollection;
  public currentActiveMenu: number;

  private elNav: HTMLElement;
  private elCarouselCircle: HTMLElement;
  private elCarousel: HTMLElement;
  private swiperCarousel: Swiper;

  private carouselTransition = 1500;
  private carouselDelay = 2000;
  private elCarouselNext: HTMLElement;

  bindings() {
    if (this.items) {
      Object.values(this.items).forEach((item) => {
        item.addEventListener('click', (e: any) => this.handlerToggleSecondaryMenu(e));
      });
    }

    this.backButtonSecondaryMenu.forEach((item) => {
      item.addEventListener('click', () => this.handlerCloseSecondaryMenu());
    });

    this.nav && this.menuToggle();

    this.initOnScrollHeaderSwitch();

    if (this.elCarousel) {
      this.swiperCarousel = new Swiper(this.elCarousel, {
        slidesPerView: 1,
        loop: true,
        parallax: true,
        speed: this.carouselTransition,
        autoplay: {
          delay: this.carouselDelay,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.l-nav__discover-products__button',
        },
      });

      this.swiperCarousel.autoplay.stop();

      this.elCarouselCircle.style.animation = `circle ${this.carouselDelay}ms linear 0s 1 normal backwards`;

      this.elCarouselNext.addEventListener('click', () => {
        this.swiperCarousel.slideNext();
        this.resetTimerNextSlide();
      });

      this.swiperCarousel.on('slideChange', ()  => {
        this.resetTimerNextSlide();
      });
    }

    this.btOpenTernaryMenu.forEach((elBt) => {
      elBt.addEventListener('click', (e: any) => this.handlerOpenTernaryMenuById(e.currentTarget.dataset.openTernaryMenuId))
    });

    this.buttonCloseTernaryMenu.forEach((elBt) => {
      elBt.addEventListener('click', () => this.handlerCloseTernaryMenu());
    });
  }

  private handlerToggleSecondaryMenu(e: any) {
    this.elNav.scrollTo(0, 0);
    if(e.currentTarget.classList.contains('is-active')) {
      this.removeActiveClass(this.items);
      this.removeActiveClass(this.innerMenu);
      this.menuFirstLevel.classList.add('is-active');
      this.menuSecondLevel.classList.remove('is-active');
      this.primaryMenu.classList.remove('has-active-link');

      this.topBar.classList.remove('is-active');
      this.btBackSecondaryMenuTopBar.classList.remove('is-active');
      this.btBackTernaryMenuTopBar.classList.remove('is-active');
      this.closeTernaryMenu();

      this.setTimerNextSlide();
      return false;
    } else {
      // Activate Button back (topbar desktop)
      this.topBar.classList.add('is-active');
      this.btBackSecondaryMenuTopBar.classList.add('is-active');
      this.btBackTernaryMenuTopBar.classList.remove('is-active');
      this.resetTimerNextSlide();
    }
    this.nav.classList.add('is-subnav');
    this.menuFirstLevel.classList.remove('is-active');
    this.primaryMenu.classList.add('has-active-link');
    this.menuSecondLevel.classList.add('is-active');
    this.closeTernaryMenu();

    this.removeActiveClass(this.items);
    e.currentTarget.classList.add('is-active');

    this.currentActiveMenu = e.currentTarget.dataset.primaryMenuId;
    this.removeActiveClass(this.innerMenu);

    // Activate second level menu selected
    const elSecondaryInnerMenu = document.querySelector('.l-nav__secondary-menu__inner-menu[data-secondary-menu-id="' + this.currentActiveMenu + '"]')
    elSecondaryInnerMenu?.classList.add('is-active');
    // Active button link from second level menu selected
    this.linksContainerPrimaryMenuTopBar.classList.add('is-active');
    this.linksPrimaryMenuTopBar.forEach((el) => el.classList.remove('is-active'));
    const elSecondaryLinkMenu = document.querySelector('.js-l-nav__top-bar-w__link[data-primary-menu-bt-id="' + this.currentActiveMenu + '"]')
    elSecondaryLinkMenu?.classList.add('is-active');
  }

  private handlerCloseSecondaryMenu() {
    this.nav.classList.remove('is-subnav');
    this.primaryMenu.classList.remove('has-active-link');
    this.menuSecondLevel.classList.remove('is-active');
    this.topBar.classList.remove('is-active');
    this.menuFirstLevel.classList.add('is-active');

    this.linksContainerPrimaryMenuTopBar.classList.remove('is-active');
    this.linksPrimaryMenuTopBar.forEach((el) => el.classList.remove('is-active'));
    this.btBackSecondaryMenuTopBar.classList.remove('is-active');
    this.btBackTernaryMenuTopBar.classList.remove('is-active');

    this.closeTernaryMenu();
    this.setTimerNextSlide();

    setTimeout(() => {
      this.elNav.scrollTo(0, 0);
    }, 300);

    this.removeActiveClass(this.items);
  }

  private handlerOpenTernaryMenuById(id: any) {
    document
      .querySelector('.l-nav__secondary-menu__inner-menu[data-secondary-menu-id="' + this.currentActiveMenu + '"]')!
      .classList.add('is-pre-active-sub');

    this.linksPrimaryMenuTopBar.forEach((el) => el.classList.remove('is-active'));

    const elSecondaryTopBarLinkTertiary = document.querySelector('.js-l-nav__top-bar-w__link-tertiary[data-primary-menu-bt-id-tertiary="' + id + '"]')
    elSecondaryTopBarLinkTertiary?.classList.add('is-active');

    setTimeout(() => {
      document
        .querySelector('.l-nav__secondary-menu__inner-menu[data-secondary-menu-id="' + this.currentActiveMenu + '"]')!
        .classList.add('is-active-sub');
      document.querySelector(`[data-ternary-menu-id="${id}"]`)?.classList.add('is-active');

      this.btBackSecondaryMenuTopBar.classList.remove('is-active');
      this.btBackTernaryMenuTopBar.classList.add('is-active');

      this.elNav.scrollTo(0, 0);
    }, 150);
  }

  private handlerCloseTernaryMenu() {
    this.closeTernaryMenu();
  }

  private closeTernaryMenu() {
    // Close all ternary menus (if active)
    this.menusTernaryLevel.forEach((el) => el.classList.remove('is-active'));
    setTimeout(() => {
      document
      .querySelector('.l-nav__secondary-menu__inner-menu[data-secondary-menu-id="' + this.currentActiveMenu + '"]')!
      .classList.remove('is-active-sub');
    }, 5);

    setTimeout(() => {
      document
      .querySelector('.l-nav__secondary-menu__inner-menu[data-secondary-menu-id="' + this.currentActiveMenu + '"]')!
      .classList.remove('is-pre-active-sub');
    }, 50);

    this.btBackSecondaryMenuTopBar.classList.add('is-active');
    this.btBackTernaryMenuTopBar.classList.remove('is-active');
    this.linksPrimaryMenuTopBarTertiary?.forEach((el) => el.classList.remove('is-active'));
    const elSecondaryLinkMenu = document.querySelector('.js-l-nav__top-bar-w__link[data-primary-menu-bt-id="' + this.currentActiveMenu + '"]');
    elSecondaryLinkMenu?.classList.add('is-active');
  }

  private setCarouselStep() {
    // if (this.isCarouselAuto === false) return;

    // this.carouselDelayTime--;

    // this.elCarouselCircle.style.strokeDashoffset = `${this.carouselDelayTime}`;
    // if (this.carouselDelayTime <= 0) {
    //   this.carouselDelayTime = 227;
    //   this.swiperCarousel.slideNext();
    // }
    // requestFrame(() => this.setCarouselStep());
  }

  private setTimerNextSlide() {
    // this.resetTimerNextSlide();
    // this.isCarouselAuto = true;
    // this.setCarouselStep();
  }

  private resetTimerNextSlide() {
    this.elCarouselCircle.removeAttribute('style');
    this.elCarouselCircle.style.strokeDashoffset = this.elCarouselCircle.style.strokeDasharray;
    this.elCarouselCircle.style.animation = 'none';
    setTimeout(() => {
      this.elCarouselCircle.style.animation = `circle ${this.carouselDelay + this.carouselTransition}ms linear 0s 1 normal backwards`;
    }, 100);
    // this.isCarouselAuto = false;
    // this.elCarouselNextStrokeLength = 227;
    // this.elCarouselCircle.style.strokeDashoffset = '0';
    // this.elCarouselNext.style.animation = '';
    // // cancelFrame(() => this.setCarouselStep());
  }

  removeActiveClass(n: HTMLCollection) {
    Object.values(n).forEach((item) => {
      item.classList.remove('is-active');
    });
  }

  menuToggle() {
    Object.values(this.menuToggler).forEach((item) => {
      item.addEventListener('click', (e: any) => {
        this.elNav.scrollTo(0, 0);
        this.nav.classList.toggle('is-active');
        document.body.classList.toggle('nav-is-open');

        this.elNav.querySelectorAll('[loading=lazy]').forEach((el: Element) => {
          el.setAttribute('loading', '');
        });

        this.nav.classList.remove('is-subnav');
        this.primaryMenu.classList.remove('has-active-link');
        this.menuSecondLevel.classList.remove('is-active');
        this.topBar.classList.remove('is-active');
        this.menuFirstLevel.classList.add('is-active');

        this.removeActiveClass(this.items);
        this.removeActiveClass(this.innerMenu);

        if(this.nav.classList.contains('is-active')) {
          this.setTimerNextSlide();
          setTimeout(() => {
            this.swiperCarousel.autoplay.start();
          }, 2000);
        } else {
          this.resetTimerNextSlide();
          this.swiperCarousel.autoplay.stop();
        }
        return false;
      });
    });
  }

  initOnScrollHeaderSwitch() {
    // Initial state check
    if (this.header) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 0) {
        this.header.classList.add('l-header--small');
        document.body.classList.add('is-header-small');
      }
    }

    window.onscroll = () => {
      setTimeout(() => {
        if (this.header) {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > 0) {
            this.header.classList.add('l-header--small');
            document.body.classList.add('is-header-small');
          }
          else {
            if (!document.querySelector('.o-roomle-iframe--is-first')) {
              this.header.classList.remove('l-header--small');
              document.body.classList.remove('is-header-small');
            }
          }
        }
      }, 300);
    };
  }

  cache() {
    this.elNav = document.querySelector('#js-l-nav') as HTMLElement;
    this.primaryMenu = document.getElementsByClassName('l-nav__primary-menu')[0];
    this.items = document.querySelectorAll('button.l-nav__primary-menu__a-link') as unknown as HTMLCollection;
    this.backButtonSecondaryMenu = document.querySelectorAll('.js-nav__2nd-bt-back');

    this.buttonCloseTernaryMenu = document.querySelectorAll('.js-nav__3rd-bt-back');
    this.btOpenTernaryMenu = document.querySelectorAll('[data-open-ternary-menu-id]');
    this.menusTernaryLevel = document.querySelectorAll('[data-ternary-menu-id]');
    this.topBar = document.querySelector('.js-l-nav__top-bar-w__back') as HTMLElement;
    this.btBackSecondaryMenuTopBar = document.querySelector('#js-l-nav__s-menu-bt-back--2nd') as HTMLElement;
    this.btBackTernaryMenuTopBar = document.querySelector('#js-l-nav__s-menu-bt-back--3rd') as HTMLElement;
    this.linksPrimaryMenuTopBar = document.querySelectorAll('.js-l-nav__top-bar-w__link');
    this.linksContainerPrimaryMenuTopBar = document.querySelector('.js-l-nav__top-bar-w__links') as HTMLElement;
    this.linksPrimaryMenuTopBarTertiary = document.querySelectorAll('.js-l-nav__top-bar-w__link-tertiary');

    this.innerMenu = document.getElementsByClassName('l-nav__secondary-menu__inner-menu');
    this.nav = document.getElementsByClassName('l-header__nav')[0];
    this.header = document.getElementsByClassName('l-header')[0];
    this.menuToggler = document.getElementsByClassName('js-menu-toggler');
    this.menuFirstLevel = document.getElementsByClassName('l-nav__secondary-menu--level-1')[0];
    this.menuSecondLevel = document.getElementsByClassName('l-nav__secondary-menu--level-2')[0];

    this.elCarousel = document.querySelector('#js-l-nav__discover') as HTMLElement;
    this.elCarouselCircle = document.querySelector('#js-l-nav__discover-circle') as HTMLElement;
    this.elCarouselNext = document.querySelector('#js-l-nav__discover-next') as HTMLElement;
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Nav;
